import React, { useEffect, useState,useRef} from "react";
import PropTypes from "prop-types";

import ApplicationComponent from "./ApplicationComponent";

import {LoadProfileAction} from '../../../redux/actions/ProfileActions';
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { useStyles } from "../../../styles/styles";
import { useHistory, Link } from 'react-router-dom';
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import SimpleMenu from "../../../components/layouts/Navigation";
import { spacing } from "@material-ui/system";
import { Box, Switch } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Slider from "@material-ui/core/Slider";
import Button from "@material-ui/core/Button";
import InputLabel from "@material-ui/core/InputLabel";
import { DropzoneArea } from "material-ui-dropzone";
import Divider from '@material-ui/core/Divider';
import DocViewer from "react-doc-viewer";
import Geographical from "../../../constants/Geographical.json";
import { viewFileAction, CustomerGeneralInfoStoreAction, LoadCustomerAction, LoadCustomerActionNormal } from '../../../redux/actions/CustomerAction';
import {useDispatch, useSelector} from 'react-redux';
import { RESTART_AUTH_RESPONSE } from "../../../redux/ActionTypes";
import { setDocumentLoading } from "react-doc-viewer/build/state/actions";
import CustomImage from '../../ImagesComponent';
import ErrorComponent from '../../ErrorComponent';
const defaultValues = {
    citizenship_number:'',
    identification_type: 'passport',
    person_doc_files: [],
    authorized_letter: [],
    province:'',
    district:'',
    city:'',
    ward:'',
    place:'',
    permanent_province:'',
    permanent_district:'',
    permanent_city:'',
    permanent_ward:'',
    permanent_place:'',
    same_permanent:true,
    is_active:'',
  role_users_id:"",
    temp:''
  };
const styles = {
  root: {
    backgroundColor: 'transparent !important',
    boxShadow: 'none',
    paddingTop: '25px',
    color: '#FFFFFF'
  },
  customButton: {
    marginTop: "15px",
    marginBottom: "30px",
    backgroundColor: "#67a8e4",
    textTransform: "Capitalize",
    clear: "both",
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingLeft: "30px",
    paddingRight: "30px",

    "&:hover": {
      background: "#67a8e4",
    },
  },
  switchRoot: {
    width: "50px!important",
    height: "24px!important",
    padding: "0px!important",
  },
  switchBase: {
    color: "#818181!important",
    padding: "1px!important",
    "&$checked": {
      "& + $track": {
        backgroundColor: "#23bf58!important",
      },
    },
  },
  thumb: {
    color: "white!important",
    width: "20px!important",
    height: "20px!important",
    margin: "1px!important",
  },
  track: {
    borderRadius: "20px!important",
    backgroundColor: "#818181!important",
    opacity: "1 !important!important",
    "&:after, &:before": {
      color: "white!important",
      fontSize: "11px!important",
      position: "absolute!important",
      top: "6px!important",
    },
    "&:after": {
      content: "'Yes'",
      left: "8px!important",
    },
    "&:before": {
      content: "'No'",
      right: "7px!important",
    },
  },
  checked: {
    color: "#23bf58 !important",
    transform: "translateX(26px) !important",
  },
  verticalGap: {
    '@media (max-width: 500px)': {
      marginTop: "20px"
    },
  },
  notifyUser:{
    
  }
}; 
function CustomGeneralInfo({ setShowPanelLicense, setShowPanelCompany, setShowMenu, setRunFirstPanel, runFirstPanel, handleChange, setReadableStatus, setRestrictedResponse, setRestrictedStatus, disableEdit,...props }){
    //const classes = useStyles();
        const {classes} = props;
    const [value, setValue] = useState(0);
    const [geo, setGeo] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [formValues, setFormValues] = useState(defaultValues);
    const [mounted, setMounted] = useState(true);
    const [dropZoneValue,setDropZoneValue] = useState([]);
    const [dropZoneALValue, setDropZoneALValue] = useState([]);
  
    const [deletedFiles, setDeletedFiles] = useState([]);
    const [flagger, setFlagger] = useState(true);
    const [editFlag, setEditFlag] = useState(false);
    const [originalData, setOriginalData] = useState(defaultValues);
    const [filesInfo, setFilesInfo] = useState([]);
  const [authorizedLetterFilesInfo, setAuthorizedLetterFilesInfo] = useState([]);
 
  const [companyReview, setCompanyReview] = useState(false);
  const [renderPage, setRenderPage] = useState(false);
    const [notification, setNotification] = useState({
       m_inactive:"",
       m_void:""
     });
 
  const history = useHistory();

   const dispatch = useDispatch();
    const customerProfile = useSelector(state => state.customerDetails.customerGeneralInformation);
    const handleInputChangeFirst = (e) => {
        const { name, value } = e.target;
        if(name==="province" || name==="permanent_province"){
            {
              const add_perm = (name==="permanent_province")?"permanent_":"";
              geo.length && geo.map((option) => (
    
                  (option.id==value)?
                    option.districts.map(  (district,index) =>(
                        (index===0)? 
                            setFormValues({
                            ...formValues,
                            [name]: value,
                            [add_perm+'district']:district.id,
                            [add_perm+'city']:district.municipalities.filter(( municipality,index)=>( index===0?true:false))[0].id,
                            [add_perm+'ward']:1
                            }): true
    
                        ))
                    :true
    
    
              )) 
          }
    
        }else if(name==="district" || name==="permanent_district"){
          const add_perm = (name==="permanent_district")?"permanent_":"";
          { geo.length && geo.map((option)=>(
             option.districts.map((option)=>(
              (option.id===value)?
                option.municipalities.map((municipality,index)=>(
                  (index===0)?
                  setFormValues({
                    ...formValues,
                    [name]: value,
                    [add_perm+'city']:municipality.id,
                    [add_perm+'ward']:1
                    }): true
                )):true
             ))
          ))
    
          }
        }else if(name==="city" || name==="permanent_city"){
          const add_perm = (name==="permanent_city")?"permanent_":"";
          setFormValues({
            ...formValues,
            [name]: value,
            [add_perm+'city']:value,
            [add_perm+'ward']:1
            })
        }else{
            setFormValues({
            ...formValues,
            [name]: value,
            });
        }
      
    
    
      };
      const handleInputChangeDropzone = (e) => {
              setDropZoneValue(e)
              setMounted(!mounted)
      };
  const handleInputChangeDropzoneAL = (e) => {
    setDropZoneALValue(e)
    setMounted(!mounted)
  };

     const enableEdit = (event) =>{
       setEditFlag(!editFlag);
     }
    const cancelEdit = (event) => {
      setEditFlag(!editFlag);
      setFormValues(originalData);
      setDeletedFiles([]);
      setDropZoneValue([])
      setDropZoneALValue([])
    }
    
      const handleSubmit = (event) => {
       event.preventDefault();
       const uploadData = new FormData();
      
       // Update the formData object
       Array.from(dropZoneValue).forEach((image_file) => {
        uploadData.append('person_doc_files[]', image_file);
    });
        // Update the formData object
        Array.from(dropZoneALValue).forEach((image_file) => {
          uploadData.append('authorized_letter[]', image_file);
        });
       
        deletedFiles.forEach((file) => {
          uploadData.append('deletedFiles[]', parseInt(file));
        });
       uploadData.append('citizenship_number', formValues.citizenship_number)
     
       uploadData.append('identification_type', formValues.identification_type)
       uploadData.append('permanent_place', formValues.permanent_place)
       uploadData.append('permanent_city', formValues.permanent_city)
       uploadData.append('permanent_ward', formValues.permanent_ward)
       uploadData.append('permanent_district', formValues.permanent_district)
       uploadData.append('permanent_province', formValues.permanent_province)
       uploadData.append('place', formValues.place)
       uploadData.append('ward', formValues.ward)
       uploadData.append('city', formValues.city)
       uploadData.append('district', formValues.district)
       uploadData.append('province', formValues.province)
      uploadData.append('same_permanent', formValues.same_permanent)
     
       uploadData.append('place', formValues.place)
    
    
        dispatch(CustomerGeneralInfoStoreAction(uploadData, setFlagger, flagger, editFlag, setEditFlag, setRenderPage));
      
        setDeletedFiles([]);
        setDropZoneValue([])
        setDropZoneALValue([])
      };

  const handleSameChange = (event) => {
    if (event.target.checked){
      setFormValues({
        ...formValues,
        [event.target.name]: event.target.checked,
        ['province']: formValues.permanent_province,
        ['district']: formValues.permanent_district,
        ['city']: formValues.permanent_city,
        ['ward']: formValues.permanent_ward,
        ['place']: formValues.permanent_place,
      });
    }else{
      setFormValues({
        ...formValues,
        [event.target.name]: event.target.checked
      });
    }
  };

      useEffect(() => {
        setLoading(true);
        setFlagger(false)
        let abortController;
        abortController = new AbortController();
        let signal = abortController.signal;  
       let customer_id = parseInt(history.location.pathname.replace('/customer-details/',''));
       
        customer_id = isNaN(customer_id) ?0: customer_id;
        let result = LoadCustomerActionNormal(customer_id, signal).then(res=>{     
          if (res.success === false && Object.keys(res.message).includes('authorization_error')) {
            setRestrictedResponse(res);
            setRestrictedStatus(true);
          }else{
         
          setGeo(Geographical)
          setFormValues({
            ...formValues,
            'identification_type': res.data.identification_type ?? "passport",
            'citizenship_number': res.data.citizenship_number ?? "",
            'person_doc_files': res.data.person_doc_files !== null ? res.data.person_doc_files : [],
            'authorized_letter': res.data.authorized_letter !== null ? res.data.authorized_letter : [],
            'province': res.data.state1 !== null ? parseInt(res.data.state1) : 1,
            'district': res.data.district1 !== null ? parseInt(res.data.district1) : 1,
            'city': res.data.city1 ? parseInt(res.data.city1) : 1,
            'ward': res.data.ward1 ? parseInt(res.data.ward1) : 1,
            'place': res.data.address1 ?? "",
            'permanent_place': res.data.address2 ?? "",
            'is_active': res.data.is_active,
            'role_users_id': res.data.role_users_id,
            'permanent_province': res.data.state2 !== null ? parseInt(res.data.state2) : 1,
            'permanent_district': res.data.district2 ? parseInt(res.data.district2) : 1,
            'permanent_city': res.data.city2 ? parseInt(res.data.city2) : 1,
            'permanent_ward': res.data.ward2 ? parseInt(res.data.ward2) : 1,
            'same_permanent': res.data.same_permanent===1?true:false,

          });
          setOriginalData({
            ...formValues,
            'identification_type': res.data.identification_type ?? "passport",
            'citizenship_number': res.data.citizenship_number ?? "",
            'person_doc_files': res.data.person_doc_files !== null ? res.data.person_doc_files : [],
            'authorized_letter': res.data.authorized_letter !== null ? res.data.authorized_letter : [],
            'province': res.data.state1 !== null ? parseInt(res.data.state1) : 1,
            'district': res.data.district1 !== null ? parseInt(res.data.district1) : 1,
            'city': res.data.city1 ? parseInt(res.data.city1) : 1,
            'ward': res.data.ward1 ? parseInt(res.data.ward1) : 1,
            'place': res.data.address1 ?? "",
            'permanent_place': res.data.address2 ?? "",
            'is_active': res.data.is_active,
            'role_users_id': res.data.role_users_id,
            'permanent_province': res.data.state2 !== null ? parseInt(res.data.state2) : 1,
            'permanent_district': res.data.district2 ? parseInt(res.data.district2) : 1,
            'permanent_city': res.data.city2 ? parseInt(res.data.city2) : 1,
            'permanent_ward': res.data.ward2 ? parseInt(res.data.ward2) : 1,
            'same_permanent': res.data.same_permanent === 1 ? true : false,

          });
          setFilesInfo(res.data.files_info);
            setAuthorizedLetterFilesInfo(res.data.authorized_letter_files_info);
          if (res.success === true && res.message === "user profile" && res.data.role_users_id !== 3 && res.data.role_users_id !== 4 && runFirstPanel) {
            setShowMenu(true);
          }
            if (res.success === true && res.message === "user profile" && [3, 4].includes(res.data.role_users_id) && res.data.is_active === 1 && res.review === false && runFirstPanel) {
              setShowPanelLicense(true);
              
         


          }
            if (res.success === true && res.message === "user profile" && [1, 2, 4, 5, 6, 7, 8, 9,10,11].includes(res.data.role_users_id) && res.data.is_active === 1 && res.review === false && runFirstPanel) {
              if([1, 2, 5, 6, 7, 8, 9,10,11].includes(res.data.role_users_id)){
                setReadableStatus(true);
              }
              setShowPanelCompany(true);



            }
            if (4==res.data.role_users_id){
              setReadableStatus(false);
            }
            setCompanyReview(res.review);
            
              setRunFirstPanel(false);
            setNotification({...notification,
              m_inactive:res.m_inactive,
              m_void:res.m_void});
        }
        
          //setShowPanelLicense(true);
         
        }).finally(()=>{
         setLoading(false);
     
        });
    
       
        //setRenderPage(false)
        return () => {
          setGeo({}); // This worked for me
          abortController.abort();
        };
      }, [renderPage == true]);
    return(
     
      <> 
        {/* {customerResponse !== '' && customerResponse.success === false && Object.keys(customerResponse.message)
          <ErrorComponent error={companyResponse.message} />
        }
       */}
        {loading && <span>Loading .....</span>}
        {!loading &&
        <>
       
           <form onSubmit={handleSubmit} style={{ textAlign: "left" }}>
                  <Grid container item xs={12}>
                    <Grid item xs={12}>
               
                {(companyReview ===false && (formValues.citizenship_number == '' || formValues.identification_type == '' ||
                  formValues.citizenship_number == '' ||
                  formValues.person_doc_files.length == 0 ||
                  formValues.place == '' ||
                  formValues.permanent_place == '')) && formValues.is_active == 0 &&
                  <ErrorComponent error={notification.m_void!=""?notification.m_void:{}} />
              
                }
                {formValues.is_active == 0 && formValues.citizenship_number != '' && formValues.identification_type != '' &&
                  formValues.citizenship_number != '' &&
                  formValues.person_doc_files.length != 0  &&
                  formValues.place != '' &&
                  formValues.permanent_place != '' &&
                  <ErrorComponent error={notification.m_inactive != "" ? notification.m_inactive : {}} />
                }
                {formValues.is_active == 1 && companyReview===true && 
                  <ErrorComponent error={notification.m_inactive != "" ? notification.m_inactive : {}} />
                }
                {!disableEdit && (formValues.role_users_id == 4 || formValues.role_users_id == 3) && 
                      <Typography variant="h6" component="div" style={{position:"relative"}} gutterBottom>
                    Authorized Personnel {!editFlag ? <span style={{ position: "absolute", top: "0px", right: "0px" }}><Button className={classes.customButton} 
                  variant="contained" color="primary" type="button" onClick={(event) => {
                    enableEdit(event);
                  }} style={{ marginTop: "15px", marginBottom: "15px" }} >
                      Enable
                  </Button></span> : <span style={{ position: "absolute", top: "0px", right: "0px" }}> <Button
                        className={classes.customButton} variant="contained" color="primary" type="button"  onClick={(event) => {
                        cancelEdit(event); 
                    }} style={{ marginTop: "15px", marginBottom: "15px" }}>
                    Cancel
                  </Button> </span>}
                      </Typography>
                 }
                <Typography variant="h6" component="div" gutterBottom>
               
                </Typography>
                    </Grid>
              <Grid item xs={12} sm={4} >
                <FormControl className={[classes.formControl, classes.verticalGap]}>
                        <FormLabel>Identification Document</FormLabel>
                        <RadioGroup
                          name="identification_type"
                          value={formValues.identification_type}
                          onChange={handleInputChangeFirst}
                          row
                          disabled={editFlag?false:true}
                        >
                          <FormControlLabel
                            key="citizenship"
                            value="citizenship"
                            control={<Radio size="small" />}
                            label="Citizenship"
                            variant="outlined"
                            disabled={editFlag ? false : true}
                          />
                          <FormControlLabel
                            key="passport"
                            value="passport"
                      control={<Radio size="small" />}
                            label="Passport"
                            variant="outlined"
                      disabled={editFlag ? false : true}
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>

              <Grid item xs={12} sm={4}>
                <FormControl variant="outlined" className={[classes.formControl, classes.verticalGap]}>
                      <TextField
                        id="citizenship-number-input"
                        name="citizenship_number"
                        margin ="normal"
                        type="text"
                        variant="outlined"
                        label="Citizenship or Passport Number"
                        value={formValues.citizenship_number}
                        onChange={handleInputChangeFirst}
                        inputlabelprops={{
                          shrink: true,
                        }}
                        disabled={editFlag ? false : true}
                      />
                      </FormControl>

                    </Grid>

                    
                   
                    <Grid
                      item
                      xs={12} container
                      style={{
                        marginTop: "15px",
                        padding: "25px",
                        border: "1px solid #ddd",
                      }}
                      >
                    <Typography
                        variant="subtitle1"
                        component="div"
                        gutterBottom
                        style={{ fontWeight: "bold",width:'100%' }}
                      >
                        Passport Or Citizenship Document
                      </Typography>
                      <Typography
                        variant="caption"
                        display="block"
                        style={{ marginBottom: "10px" }}
                        gutterBottom
                      >
                        Note* Upload both sides ,front and back.
                      </Typography>
                  <Grid
                    item
                    xs={12} container
                    style={{
                      marginTop: "15px",
                      marginBottom: "15px",
                      padding: "25px",
                      border: "1px solid #ddd",
                    }}
                  > 
                  {formValues.person_doc_files.length != 0 &&
                    formValues.person_doc_files.map((option, index) => (

                      (deletedFiles.length && deletedFiles.includes(option)) ?
                        false
                        :
                        <CustomImage option={option} index={index} deletedFiles={deletedFiles}
                          setDeletedFiles={setDeletedFiles} key={index} editFlag={editFlag} filesInfo={filesInfo} />

                    ))
                  }
                  </Grid>
                {editFlag &&
                       <DropzoneArea
                        acceptedFiles={[
                          "image/*",
                          "application/pdf",
                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                          
                        ]}
                        name="person_doc_files"
                        id="person_doc_files"
                        filesLimit={5}
                        dropzoneText="Drop files here or click to upload."
                        onChange={handleInputChangeDropzone}
                        showPreviews={true}
                        showPreviewsInDropzone={false}
                        useChipsForPreview
                        previewGridProps={{ container: { spacing: 1, direction: 'row' } }}
                        previewChipProps={{ classes: { root: classes.previewChip } }}
                        previewText="Selected files"
                        maxFileSize={204800000000}
                        multiple
                        dropzoneParagraphClass={classes.dropzoneParagraphClass}
                        
                      /> 
                }
                    </Grid>
              <Grid
                item
                xs={12} container
                style={{
                  marginTop: "15px",
                  padding: "25px",
                  border: "1px solid #ddd",
                }}
              >
                <Typography
                  variant="subtitle1"
                  component="div"
                  gutterBottom
                  style={{ fontWeight: "bold", width: '100%' }}
                >
                  Authorized letter Document
                </Typography>
                <Typography
                  variant="caption"
                  display="block"
                  style={{ marginBottom: "10px" }}
                  gutterBottom
                >
                  Note* Upload Authorized letter.
                </Typography>
                <Grid
                  item
                  xs={12} container
                  style={{
                    marginTop: "15px",
                    marginBottom: "15px",
                    padding: "25px",
                    border: "1px solid #ddd",
                  }}
                >
                  {formValues.authorized_letter!=undefined && formValues.authorized_letter.length != 0 &&
                    formValues.authorized_letter.map((option, index) => (

                      (deletedFiles.length && deletedFiles.includes(option)) ?
                        false
                        :
                        <CustomImage option={option} index={index} deletedFiles={deletedFiles}
                          setDeletedFiles={setDeletedFiles} key={index} editFlag={editFlag} filesInfo={authorizedLetterFilesInfo} />

                    ))
                  }
                </Grid>
                {editFlag &&
                  <DropzoneArea
                    acceptedFiles={[
                      "image/*",
                      "application/pdf",
                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

                    ]}
                    name="authorized_letter"
                     id="authorized_letter"
                    filesLimit={5}
                    dropzoneText="Drop files here or click to upload."
                    onChange={handleInputChangeDropzoneAL}
                  showPreviews={true}
                  showPreviewsInDropzone={false}
                  useChipsForPreview
                  previewGridProps={{ container: { spacing: 1, direction: 'row' } }}
                  previewChipProps={{ classes: { root: classes.previewChip } }}
                  previewText="Selected files"
                    maxFileSize={204800000000}
                    multiple
                    dropzoneParagraphClass={classes.dropzoneParagraphClass}

                  />
                }
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h6" component="div" gutterBottom style={{ marginTop: "30px", marginBottom: "30px" }}>
                  Permanent Address
                </Typography>
              </Grid>
              <Grid item xs={12} sm={3} >
                <FormControl variant="outlined" className={[classes.formControl, classes.verticalGap]}>

                  <InputLabel>Select Province</InputLabel>
                  <Select
                    name="permanent_province"
                    label={"Select Province"}
                    value={formValues.permanent_province}
                    onChange={handleInputChangeFirst}
                    disabled={editFlag ? false : true}
                  >

                    {geo.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={3} >

                <FormControl variant="outlined" className={[classes.formControl, classes.verticalGap]}>
                  <InputLabel>Select District</InputLabel>

                  <Select
                    name="permanent_district"
                    label={"Select District"}
                    value={formValues.permanent_district}
                    onChange={handleInputChangeFirst}
                    disabled={editFlag ? false : true}

                  >

                    {geo.length && geo.map((option) => (

                      (option.id === formValues.permanent_province) ?
                        option.districts.map((option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {option.name}

                          </MenuItem>
                        ))
                        : true


                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={3}  >

                <FormControl variant="outlined" className={[classes.formControl, classes.verticalGap]}>
                  <InputLabel>Select City</InputLabel>
                  <Select
                    name="permanent_city"
                    label={"Select City"}
                    value={formValues.permanent_city}
                    onChange={handleInputChangeFirst}
                    disabled={editFlag ? false : true}
                  >

                    {geo.length && geo.map((option) => (

                      option.districts.map((option) => (

                        (option.id === formValues.permanent_district) ?
                          option.municipalities.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                              {option.name}

                            </MenuItem>
                          ))

                          : true
                      ))
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={3} >

                <FormControl variant="outlined" className={[classes.formControl, classes.verticalGap]}>
                  <InputLabel>Select Ward</InputLabel>
                  <Select
                    name="permanent_ward"
                    label={"Select Ward"}
                    value={formValues.permanent_ward}
                    onChange={handleInputChangeFirst}
                    disabled={editFlag ? false : true}
                  >

                    {geo.length && geo.map((option) => (

                      option.districts.map((option) => (

                        option.municipalities.map((option) => (
                          (option.id === formValues.permanent_city) ?
                            option.wards.map((ward) => (
                              <MenuItem key={ward} value={ward}>
                                {"Ward " + ward}

                              </MenuItem>
                            )) : true
                        ))
                      ))
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={3} >
                <FormControl >
                  <TextField
                    id="name-input-permanent_place"
                    name="permanent_place"
                    label="Select Place"
                    margin="normal"
                    variant="outlined"
                    value={formValues.permanent_place}
                    onChange={handleInputChangeFirst}
                    inputlabelprops={{
                      shrink: true,
                    }}
                    disabled={editFlag ? false : true}
                    className={[classes.formControl, classes.verticalGap]}
                  />
                </FormControl>
              </Grid>
              
              <Divider />
                    <Grid item xs={12}>
                <Typography variant="h6" component="div" gutterBottom style={{ marginBottom: "30px" }}>
                        Temporary Address
                      </Typography>
                <Typography variant="p" component="div" gutterBottom style={{ marginBottom: "30px" }}>
                  Same As Permanent Address <Switch
                    classes={{
                      root: classes.switchRoot,
                      switchBase: classes.switchBase,
                      thumb: classes.thumb,
                      track: classes.track,
                      checked: classes.checked
                    }}
                    checked={formValues.same_permanent}
                    onChange={handleSameChange}
                    id="same_permanent"
                    name="same_permanent"
                    inputProps={{ "aria-label": "secondary checkbox" }}
                    disabled={editFlag ? false : true}
                  />
                  </Typography>
                    </Grid>
              {!formValues.same_permanent && 
              <>
                <Grid item xs={12} sm={3}  >
                  <FormControl variant="outlined" className={[classes.formControl, classes.verticalGap]} >
                    <InputLabel>Select Province</InputLabel>
                        <Select
                          name="province"
                          label={"Select Province"}
                          value={formValues.province}
                          onChange={handleInputChangeFirst} 
                    disabled={(editFlag && !formValues.same_permanent) ?false:true}
                        >
                            
                        {geo.map((option) => (
                                <MenuItem key={option.id} value={option.id}>
                                    {option.name}
                                </MenuItem>
                        ))}
                        </Select>
                      </FormControl>
                    </Grid>
                <Grid item xs={12} sm={3} >
                      
                  <FormControl variant="outlined" className={[classes.formControl, classes.verticalGap]}>
                      <InputLabel>Select District</InputLabel>
                        <Select
                          name="district"
                          label={"Select District"}
                          value={formValues.district}
                          onChange={handleInputChangeFirst}
                    disabled={(editFlag && !formValues.same_permanent) ? false : true}
                        >
                            
                        {geo.length && geo.map((option) => (
                          
                           (option.id===formValues.province)?
                           option.districts.map((option) =>(
                             <MenuItem key={option.id} value={option.id}>
                            {option.name}</MenuItem>
                         ))
                            :true
                          
                      
                        )) }
                        </Select>
                      </FormControl>
                    </Grid>
                <Grid item xs={12} sm={3} >
                      
                    <FormControl variant="outlined" className={[classes.formControl,classes.verticalGap]}>
                      <InputLabel>Select City</InputLabel>
                        <Select
                          name="city"
                          label={"Select City"}
                          value={formValues.city}
                          onChange={handleInputChangeFirst} 
                    disabled={(editFlag && !formValues.same_permanent) ? false : true}
                        >
                            
                        {geo.length && geo.map((option) => (
                          
                                option.districts.map((option)=>(
                                  
                                   (option.id===formValues.district)?
                                   option.municipalities.map((option) =>(
                                    <MenuItem key={option.id} value={option.id}>
                                          {option.name}
                                   
                                    </MenuItem>
                                    )):true
                                ))
                        )) }
                        </Select>
                      </FormControl>
                    </Grid>
                <Grid item xs={12} sm={3} >
                      
                  <FormControl variant="outlined" className={[classes.formControl, classes.verticalGap]}>
                      <InputLabel>Select Ward</InputLabel>
                        <Select
                          name="ward"
                          label={"Select Ward"}
                          value={formValues.ward}
                          onChange={handleInputChangeFirst} 
                    disabled={(editFlag && !formValues.same_permanent) ? false : true}
                        >
                           
                        {geo.length && geo.map((option) => (
                          
                                option.districts.map((option)=>(
                                  
                                    option.municipalities.map((option)=>(
                                      (option.id===formValues.city)?
                                       option.wards.map((ward)=>(
                                        <MenuItem key={ward} value={ward}>
                                        {"Ward " + ward}
                                        
                                      </MenuItem>
                                       )):true
                                    ))
                                ))
                        )) }
                        </Select>
                      </FormControl>
                    </Grid>
                <Grid item xs={12} sm={3} >
                  <FormControl variant="outlined" className={[classes.formControl, classes.verticalGap]}>
                      
                      <TextField
                        id="name-input"
                        name="place"
                        margin="normal"
                        variant="outlined"
                        label="Select Place"
                        value={formValues.place}
                        onChange={handleInputChangeFirst}
                        inputlabelprops={{
                          shrink: true,
                        }}
                    disabled={(editFlag && !formValues.same_permanent) ? false : true}
                      />
                      </FormControl>
                    </Grid>
                    </>
                }
              {(formValues.role_users_id == 4 || formValues.role_users_id == 3) && 
                    <Grid item xs={12} >
                <Button className={classes.customButton} variant="contained" color="primary" type="submit" style={{ marginTop: "15px", marginBottom: "15px" }} disabled={editFlag ? false : true}>
                      Submit
                    </Button>
                    </Grid>
              }
                  </Grid>
                </form>
            </>
        }
    </>
                  
    );

  }
export default withStyles(styles)(CustomGeneralInfo);
